import React from 'react'
import { connect } from 'react-redux'
import { ContentHeader, StaticBox, FlowTable, Modal } from 'components/basic'
import FlowView from 'components/core/FlowView'
import ReactHtmlParser from 'react-html-parser'
import { date } from 'helpers'
import { Installation } from 'config'
import http from 'API/http'
import Select from 'react-select'

class TicketOverview extends FlowView {
  constructor (props) {
    super(props, 'Tickets')
    this.state = {
      tickets: [],
      modalState: false,
      statusFilter: '',
      loading: true,
      order: 'DESC'
    }
  }
  componentDidMount () {
    this.getTickets()
  }
  async getTickets (sortBy) {
    this.setState({loading: true})
    if (!Installation.enable.ticketsCreate) this.setState({modalState: true})
    var [err, res] = await http.get('2.4/tickets', {
      status: this.state.statusFilter,
      order: this.state.order,
      sortBy: sortBy
    })
    if (err) return this.setState({tickets: [], loading: false})
    this.setState({tickets: res.data, loading: false, sortBy: sortBy, order: (this.state.order === 'DESC' ? 'ASC' : 'DESC')})
  }
  getStatus (status) {
    switch (status) {
      case 0:
        return 'NEW'
      case 1:
        return 'OPEN'
      case 2:
        return 'CLEARED'
      case 3:
        return 'CLOSED'
      default:
        return status
    }
  }

  setStatus (status) {
    switch (status) {
      case 'CREATED':
        return <span className='label orders-label label-success'><b>{status}</b></span>
      case 'IN_PROGRESS_CO':
        return <span className='label orders-label label-primary'><b>{status}</b></span>
      case 'IN_PROGRESS_SP':
        return <span className='label orders-label label-warning'><b>{status}</b></span>
      case 'CLOSED':
        return <span className='label orders-label label-danger'><b>{status}</b></span>
      default:
    }
  }

  render () {
    return (
      <div className='content-wrapper'>
        <ContentHeader title='Trouble Tickets' subtitle='Overview' />
        <hr />
        <div className='row'>
          <StaticBox cols={12} icon='filter' title='Filter'>
            <div className='row'>
              <div className='col-md-2 col-sm-4'>
                <span className='access-filter-name'>Filter by Status</span>
              </div>
              <div className='col-md-10'>
                <Select
                  searchable
                  labelKey='value'
                  valueKey='value'
                  clearable
                  value={this.state.statusFilter}
                  options={[{value: 'CREATED'}, {value: 'IN_PROGRESS_SP'}, {value: 'IN_PROGRESS_CO'}, {value: 'CLOSED'}]}
                  onChange={(state) => this.setState({statusFilter: (state ? state.value : '')}, this.getTickets)}
                />
              </div>
            </div>
          </StaticBox>
          <StaticBox cols={12} icon='ticket' title='Tickets'>
            <FlowTable
              loading={this.state.loading}
              paginatable={20}
              data={this.state.tickets.map(ticket => [
                { onClick: e => (window.location.href = '/#/ticket/' + ticket.coTicketReference) },
                <a href={'/#/ticket/' + ticket.coTicketReference} className='table-link'><i className='fa fa-folder-open-o' /></a>,
                ticket.coTicketReference,
                this.setStatus(ticket.status),
                <p style={{'width': '300px'}} className='ellipsis no-margin'>{ticket.heading}</p>,
                <p style={{'width': '300px'}} className='ellipsis no-margin'>{ticket.description}</p>,
                ticket.priority,
                ticket.spReference,
                date.utc(ticket.createdAt),
                date.utc(ticket.updatedAt),
                ticket.responsible
              ])}>
              <tr>
                <th className='buttons' />
                <th onClick={e => { this.getTickets('ticketNumber') }} className='clickable'>{this.state.sortBy === 'ticketNumber' && (this.state.order === 'DESC' ? <i className='fa fa-caret-down' /> : <i className='fa fa-caret-up' />)} ID</th>
                <th onClick={e => { this.getTickets('status') }} style={{'width': '120px'}} className='clickable'>{this.state.sortBy === 'status' && (this.state.order === 'DESC' ? <i className='fa fa-caret-down' /> : <i className='fa fa-caret-up' />)} Status</th>
                <th onClick={e => { this.getTickets('subject') }} className='clickable'>{this.state.sortBy === 'subject' && (this.state.order === 'DESC' ? <i className='fa fa-caret-down' /> : <i className='fa fa-caret-up' />)} Title</th>
                <th onClick={e => { this.getTickets('description') }} className='clickable'>{this.state.sortBy === 'description' && (this.state.order === 'DESC' ? <i className='fa fa-caret-down' /> : <i className='fa fa-caret-up' />)} Description</th>
                <th onClick={e => { this.getTickets('priority') }} className='clickable'>{this.state.sortBy === 'priority' && (this.state.order === 'DESC' ? <i className='fa fa-caret-down' /> : <i className='fa fa-caret-up' />)} Priority</th>
                <th onClick={e => { this.getTickets('reference') }} className='clickable'>{this.state.sortBy === 'reference' && (this.state.order === 'DESC' ? <i className='fa fa-caret-down' /> : <i className='fa fa-caret-up' />)} Reference</th>
                <th onClick={e => { this.getTickets('created') }} className='clickable'>{this.state.sortBy === 'created' && (this.state.order === 'DESC' ? <i className='fa fa-caret-down' /> : <i className='fa fa-caret-up' />)} Created</th>
                <th onClick={e => { this.getTickets('updated') }} className='clickable'>{this.state.sortBy === 'updated' && (this.state.order === 'DESC' ? <i className='fa fa-caret-down' /> : <i className='fa fa-caret-up' />)} Updated</th>
                <th onClick={e => { this.getTickets('assignee') }} className='clickable'>{this.state.sortBy === 'assignee' && (this.state.order === 'DESC' ? <i className='fa fa-caret-down' /> : <i className='fa fa-caret-up' />)} Assignee</th>
              </tr>
            </FlowTable>
          </StaticBox>
        </div>
        <Modal title='Ticket Information' isOpen={this.state.modalState} close={e => this.setState({modalState: false})}>
          {ReactHtmlParser(Installation.ticketRules)}
        </Modal>
      </div>
    )
  }
}
//eslint-disable-next-line
TicketOverview = connect(state => state.siteReducer)(TicketOverview)
export default TicketOverview



// WEBPACK FOOTER //
// ./src/projects/access-gui/views/ticket/overview.js